export const UPDATE_ASSET = "VIDEO";
export const PLAYER_EVENT = "VIDEO_EVENT";
export const FILTERED = "FILTERED";
export const SCROLL = "SCROLL";
export const CURRENT_VIDEO = "CURRENT_VIDEO";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const UPDATE_BREADCRUMBS = "UPDATE_BREADCRUMBS";
export const UPDATE_PRODUCT_MODAL = "UPDATE_PRODUCT_MODAL";